import React, { useState } from 'react';
import { auth } from '../firebase'; // استيراد المصادقة من Firebase
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg'

const PartnerLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // تسجيل الدخول باستخدام البريد الإلكتروني وكلمة المرور
      await signInWithEmailAndPassword(auth, email, password);
      // إعادة التوجيه إلى صفحة ملف الشريك أو لوحة القيادة
      navigate('/partner-profile'); // تغيير المسار إلى صفحة الملف الشخصي للشريك
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="relative min-h-screen flex justify-center items-center bg-gradient-to-t from-green-400 to-green-100">
       <img src={logo} alt='logo' className='bg-transparent blur-sm w-full h-full absolute p-40'/>
      <div className="backdrop-blur-md absolute rounded-3xl bg-transparent shadow-lg w-full max-w-4xl h-max z-20 p-48 ">
        <h2 className="text-4xl font-semibold text-center mb-20">تسجيل دخول الشريك</h2>
        {error && <p className="text-red-500 text-center mb-6">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4 bg-transparent">
          <div className=''>
            <label htmlFor="email" className="block text-xl mb-4 font-medium text-gray-700">البريد الإلكتروني</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-6 py-4 border-b-4 placeholder:text-gray-900 autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
              required
              placeholder='البريد الإلكتروني'
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-xl mb-4 font-medium text-gray-700">كلمة المرور</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-6 py-4 mb-10 border-b-4 placeholder:text-gray-900 autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
              required
              placeholder='كلمة المرور'
            />
          </div>
          <button
            type="submit"
            className="bg-[#189475] mx-auto text-white text-center text-2xl px-8 py-6 mt-20 rounded-full flex justify-center items-center hover:bg-green-300 transition-colors"
          >
            تسجيل دخول الشريك
          </button>
        </form>
      </div>
    </div>
  );
};

export default PartnerLoginPage;
